import React from "react";
import { UserAssessmentResult, UserCertification } from "../model/certification";
import { Loader } from "./loader";

import { TableRow, TableCell, IconButton, Collapse, Box, Table, TableHead, TableBody } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Assessment } from "../model/module";
import { Check, CheckBox, CheckBoxOutlineBlank, CheckBoxOutlined, Close, Verified } from "@mui/icons-material";
import { Session } from "../model/session";
import { Course } from "../model/course";


export const UserCertAssessmentRow = (props: { userCert: UserCertification, course: Course, assessments: Assessment[] }) => {
    const { userCert, course, assessments } = props;
    const [open, setOpen] = React.useState(false);
  
    if (assessments.length == 0) {
        return
    }

    const matchingAssesmentResult = (assessment: Assessment, results: UserAssessmentResult[]): UserAssessmentResult | undefined => {
      return results.find(result => result.assessmentId == assessment.uuid)
    }


    const countPassedAssessments = (assessments: Assessment[], results: UserAssessmentResult[]): number => {
        let validIds = assessments.map(a => a.uuid)
        let passed = results.filter(result => result.passed && validIds.includes(result.assessmentId))
        return passed.length
    }
    
    return (
      <React.Fragment>
        <TableRow>
          <TableCell  width={140}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell width={100}>{countPassedAssessments(assessments, userCert.assessments)} / {assessments.length}</TableCell>
          <TableCell>{course.name}</TableCell>
        </TableRow>

        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="assessmentInfo">
                  <TableHead>
                    <TableRow>
                        <TableCell/>
                        <TableCell></TableCell>
                        <TableCell>Assessment</TableCell>
                        <TableCell>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      assessments.map((assessment) => {
                          let matchingAssesment = matchingAssesmentResult(assessment, userCert.assessments)
                          if (!matchingAssesment) {
                            // no matching if there is no record of user doing the assessment
                            return(
                                <TableRow>
                                    <TableCell width={130}/>
                                    <TableCell width={100}/>
                                    <TableCell width={50}>{assessment?.title}</TableCell>
                                    <TableCell>{""}</TableCell>
                                </TableRow>
                            )
                          }

                          return(
                            <TableRow>
                                <TableCell width={130}/>
                                <TableCell width={100}>{matchingAssesment.passed ? <CheckIcon/>: <Close/>}</TableCell>
                                <TableCell width={200}>{assessment?.title}</TableCell>
                                <TableCell>{matchingAssesment.dateFormatted}</TableCell>
                            </TableRow>
                          )
                      })
                    }
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }